<div *ngIf="titleImage" class="landing-dialog-title-image-wrapper">
  <span class="landing-dialog-title-image" [ngClass]="titleImage"></span>
</div>
<div class="landing-dialog-title">{{ dialogTitle }}</div>
